var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRecents = function SvgRecents(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1BD",
    d: "M6 10.8c2.64 0 4.8-2.16 4.8-4.8S8.64 1.2 6 1.2 1.2 3.36 1.2 6s2.16 4.8 4.8 4.8M6 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m.3 6.48L3.42 8.16 3 7.32l2.4-1.38V3h.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRecents);
export { ForwardRef as ReactComponent };